// import noScroll from 'no-scroll';

export const drawer = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (function(window, document, $) {
    const $drawer = $(".drawer"); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const $drawerNav = $(".drawer-nav > div"); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const $drawerMenus = $(".js-drawerMenu"); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const bodyElement = document.body;
    const classes = {
      open: "-is-open",
      close: "-is-close"
    };
    if ($drawer.length === 0 || !bodyElement) return;

    const initializeChildMenus = () => {
      $drawerMenus.each((ei, e) => {
        const $this = $(e);
        const $childMenu = $this.next();

        $this.addClass(classes.close);
        $childMenu.hide();
      });
    };

    const drawerOpen = (): void => {
      initializeChildMenus();
      bodyElement.classList.remove("drawer-close");
      bodyElement.classList.add("drawer-open");
      $drawerNav.scrollTop(0);
      // if (typeof noScroll === 'object') {
      //   noScroll.on();
      // }
    };
    const drawerClose = (): void => {
      bodyElement.classList.remove("drawer-open");
      bodyElement.classList.add("drawer-close");
    };
    const drawerDestroy = (): void => {
      bodyElement.classList.remove("drawer-open");
      bodyElement.classList.remove("drawer-close");
    };

    const drawerIsInitialized = () => {
      return bodyElement.classList.contains("drawer-close") || bodyElement.classList.contains("drawer-open");
    };

    const drawerIsClose = () => bodyElement.classList.contains("drawer-close");
    const drawerIsOpen = () => bodyElement.classList.contains("drawer-open");

    /**
     * Events
     */
    const $drawerToggle = $(".drawer-toggle");
    $drawerToggle.on("touchend click", (e) => {
      e.preventDefault();
      if (drawerIsClose()) {
        drawerOpen();
      } else {
        drawerClose();
      }
    });
    $drawerMenus.on("touchend click", (e) => {
      e.preventDefault();
      const $this = $(e.target);
      const $childMenu = $this.next();

      if ($this.hasClass(classes.open)) {
        $this.removeClass(classes.open);
        $this.addClass(classes.close);
      } else {
        $this.removeClass(classes.close);
        $this.addClass(classes.open);
      }

      $($childMenu).slideToggle();
    });
    window.addEventListener("resize", () => {
      if (drawerIsOpen()) {
        drawerClose();
      }
    });


    /**
     * Init
     */
    const activeBreakPointValue = getComputedStyle(document.documentElement).getPropertyValue("--global-breakpoint--full");
    if (!activeBreakPointValue) {
      return;
    }
    const drawerBreakpoint = window.matchMedia("(min-width: " + activeBreakPointValue + ")");
    const handleMediaQuery = (mediaQuery) => {
      if (mediaQuery.matches) {
        if (drawerIsInitialized()) {
          drawerDestroy();
        }
      } else {
        if (drawerIsInitialized()) return;

        initializeChildMenus();
        drawerClose();
      }
    };
    // Register
    handleMediaQuery(drawerBreakpoint);
    drawerBreakpoint.addListener(handleMediaQuery);
  })(window, document, jQuery);
};
